import React from 'react';
import axios from 'helpers/axios';
import { useParams } from 'react-router-dom';

import { Container, Title, TextInput, Button, Form, Image } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useToasts, useUser, useLayout } from 'hooks';

export const ResetPassword = ({ _token = null }) => {
  const [state, setState] = React.useState({ newPassword: '', verifyPassword: '' });
  const { setLayoutLoading } = useLayout();
  const { errorToast } = useToasts();
  const { redirectTo } = useUser();
  const { token = _token } = useParams();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (state.newPassword !== state.verifyPassword) {
      errorToast('Passwords does not match!');
      return;
    }
    try {
      setLayoutLoading(true);
      const response = await axios.post(`/auth/reset/${token}`, state);
      if (response.status === 200) {
        redirectTo('/reset-password/success');
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Password reset.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="reset-password" src="/assets/img/reset-password.svg" />
        </Container>
        <Title mb="m">New password</Title>
        <Title type="h3" variant="grey" mb="m">
          Please enter new password
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container mb="m">
            <TextInput
              name="newPassword"
              type="password"
              minLength="10"
              placeholder="New password"
              value={state.newPassword}
              onChange={handleChange}
              required
              autoFocus
            />
          </Container>
          <Container mb="xs">
            <TextInput
              name="verifyPassword"
              type="password"
              minLength="10"
              placeholder="Confirm password"
              value={state.verifyPassword}
              onChange={handleChange}
              required
            />
          </Container>
          <Button type="submit" my="m">
            Confirm
          </Button>
        </Form>
      </Container>
    </AuthLayout>
  );
};
